import { theme } from "../../../../theme";
export const calendarStyles = {
    borderRadius: 10,
};
export const calendarTheme = {
    textDayFontFamily: "Proxima",
    textMonthFontFamily: "ProximaBold",
    textDayHeaderFontFamily: "Proxima",
    todayTextColor: theme.colors.dark.base,
    textDisabledColor: theme.colors.greyscale.lightest,
    dayTextColor: theme.colors.dark.base,
    textDayFontSize: theme.fontDefaults.xsmall.fontSize,
    arrowColor: theme.colors.brand.base,
    textMonthFontSize: theme.fontDefaults.xsmall.fontSize,
    "stylesheet.calendar.main": {
        dayContainer: {
            margin: 2,
        },
        week: {
            marginVertical: 0,
            flexDirection: "row",
            justifyContent: "space-around",
        },
    },
};
export const selectableDateStyles = (color) => ({
    customStyles: {
        container: {
            backgroundColor: theme.colors[color].lightest,
            borderRadius: theme.spacing.xsmall2,
        },
        text: {
            color: theme.colors.dark.base,
        },
    },
});
//# sourceMappingURL=InputDate.styles.js.map